<script>
	// @ts-nocheck
	import TripadvisorAward from '$lib/components/TripadvisorAward.svelte';
	// Per-tour reviews carousel. Mirrors the home-page Testimonials component
	// exactly in layout/structure, but loops the tour's own reviews and shows a
	// single review per slide. Renders nothing unless the tour's productCode has
	// an entry in tourReviews.
	import * as Carousel from '$lib/components/ui/carousel';
	import * as Card from '$lib/components/ui/card';
	import { Star } from 'lucide-svelte';
	import { tourReviews } from '$lib/data/tourReviews';

	let { tour } = $props();

	let reviews = tourReviews.find((t) => t.productCode === tour.productCode)?.reviews ?? [];
</script>

{#if reviews.length > 0}
	<section class="mx-auto flex max-w-7xl flex-col px-4 pb-20 pt-12 lg:pt-20">
		<h2
			class="scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
		>
			Don't take our word for it, hear from our adventurers
		</h2>
		<div class="mx-auto mt-6 w-full max-w-7xl pb-12 lg:mt-12">
			<div class="group col-span-1 flex w-full flex-col">
				<div
					class="relative flex overflow-hidden rounded-2xl bg-gray-900 px-6 pb-32 pt-12 shadow-xl sm:px-10 md:px-12 lg:h-[350px] lg:items-center lg:rounded-3xl lg:px-20 lg:py-20"
				>
					<enhanced:img
						class="absolute inset-0 h-full w-full object-cover"
						src="/src/lib/assets/images/cradle-mountain.jpg"
						alt="Thousands of 5 star reviews and counting"
						loading="lazy"
					/>
					<div class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all"></div>

					<div class="relative mx-auto max-w-xl lg:mx-0">
						<h3
							class="text-center font-heading text-2xl font-bold text-background lg:text-left lg:text-4xl"
						>
							2 000+ 5 star reviews and counting
						</h3>
					</div>
				</div>
			</div>
			<div class="mx-auto grid-cols-4 lg:grid">
				<div class="col-span-1 hidden flex-col pt-4 lg:flex">
					<TripadvisorAward />
					<enhanced:img
						src="/src/lib/assets/images/tassie-specialist.png"
						alt="Tassie Specialist Award Winner"
						class="ml-8 mt-4 w-36"
						loading="lazy"
					/>
				</div>
				<div class="col-span-3 -mt-24 px-8 lg:px-0 lg:pr-12">
					<Carousel.Root class="w-full" opts={{ align: 'start', loop: true }}>
						<Carousel.Content peek>
							{#each reviews as review}
								<Carousel.Item class="w-full basis-[85%] lg:basis-full">
									<div class="w-full text-left">
										<Card.Root
											class="w-full overflow-hidden rounded-2xl border-none bg-muted shadow-none"
										>
											<Card.Header class="relative w-full ">
												<div class="flex gap-0">
													{#each Array(review.rating ?? 5) as _}
														<Star class="fill-tt-red text-tt-red" />
													{/each}
												</div>
												<Card.Title class="line-clamp-2 h-14 font-heading text-lg leading-snug">
													{review.title}
												</Card.Title>
												<Card.Description class="  ">
													{[review.author, review.date].filter(Boolean).join(' · ')}
												</Card.Description>
											</Card.Header>
											<Card.Content class="grid  gap-4">
												<div class="relative">
													<p class="h-48 overflow-hidden">{review.content}</p>
													<div
														class="absolute -bottom-6 h-12 w-full bg-gradient-to-t from-muted to-transparent"
													></div>
												</div>
											</Card.Content>
										</Card.Root>
									</div>
								</Carousel.Item>
							{/each}
						</Carousel.Content>
						<Carousel.Previous class="hidden lg:flex" />
						<Carousel.Next class="hidden lg:flex" />
					</Carousel.Root>
				</div>
			</div>
		</div>
	</section>
{/if}
